import React from "react";
import { VideraMark } from "@/components/VideraMark";

/**
 * The horizontal Videra lockup: mark, hairline rule, wordmark. Use `tone="light"` on dark panels.
 * Vector throughout, so it stays crisp from a 20px ribbon to a print header.
 */
const NAVY = "#123A5A";
const ACCENT = "#005EB8";

export const VideraLogo = ({ height = 28, tone = "dark", className = "", ...rest }) => {
  const ink = tone === "light" ? "#FFFFFF" : NAVY;
  const accent = tone === "light" ? "#9CC4FF" : ACCENT;
  const rule = tone === "light" ? "rgba(255,255,255,0.35)" : "rgba(18,58,90,0.25)";

  return (
    <span
      className={`inline-flex items-center gap-2.5 ${className}`}
      style={{ height }}
      data-testid="videra-logo"
      {...rest}
    >
      <VideraMark size={height} color={ink} accent={accent} />
      <span aria-hidden="true" style={{ width: 1, height: height * 0.72, background: rule }} />
      <span
        className="font-marketing-display font-black uppercase leading-none"
        style={{ color: ink, fontSize: height * 0.6, letterSpacing: "0.01em" }}
      >
        Videra
      </span>
    </span>
  );
};

export default VideraLogo;
